import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import styled from 'styled-components';

import { responsive, focusOutline } from '@hivebrite/design-system/Theme';
import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';
import { useIsMobileDevice } from '@hivebrite/react-hooks';

import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

import useHeaderTheme from '../hooks/useHeaderTheme';

const HeaderDefaultLink = ({
  children = null,
  activeIcon,
  defaultIcon,
  onClick,
  tooltip,
  fixedParent,
  ...props
}) => {
  const headerTheme = useHeaderTheme();

  const isMobileDevice = useIsMobileDevice();
  const [isActiveIcon, setIsActiveIcon] = useState(false);
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false);

  const handleFocus = useCallback(() => {
    if (!isMobileDevice) {
      setIsActiveIcon(true);
      setIsTooltipDisplayed(true);
    }
  }, [isMobileDevice]);

  const handleBlur = useCallback(() => {
    setIsActiveIcon(false);
    setIsTooltipDisplayed(false);
  }, []);

  const handleMouseEnter = useCallback(() => {
    if (!isMobileDevice) {
      setIsActiveIcon(true);
    }
  }, [isMobileDevice]);

  const handleMouseLeave = useCallback(() => {
    setIsActiveIcon(false);
  }, []);

  return (
    <Wrapper
      onMouseDown={handleBlur}
      onMouseUp={onClick}
      onKeyDown={onEnterOrSpacePress(onClick)}
      role="button"
      tabIndex={0}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      $headerColor={headerTheme.color}
      {...props}
    >
      <Tooltip
        initialPosition={POSITIONS.BOTTOM}
        childrenElement={tooltip}
        hideOnScreenReader
        shouldRenderTooltip={isTooltipDisplayed}
        fixedParent={fixedParent}
      >
        {isActiveIcon ? activeIcon : defaultIcon}
        {children}
      </Tooltip>
    </Wrapper>
  );
};

HeaderDefaultLink.propTypes = {
  activeIcon: PropTypes.node,
  defaultIcon: PropTypes.node,
  onClick: PropTypes.func,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default HeaderDefaultLink;

const Wrapper = styled.div`
  display: inline-block;
  padding: 0.8em 0.5em;
  cursor: pointer;
  ${focusOutline}
  ${responsive('l')`
    padding: .8em 1.5em;
  `}
`;
